import React, { useState } from "react";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
export function TreeItem({ title, children,toggled }) {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div style={{marginBottom:'10px',width:"470px"}}>
     <div className="list-item"
      style={{display:'flex',color:'white',fontSize:'16px'}}
        onClick={() => setIsOpen(!isOpen)}>
        <div >{children ? (isOpen||toggled ? <ArrowDropDownIcon fontSize="x-large"/> : <ArrowRightIcon fontSize="x-large"/>) : ""}</div>
        <div>{title}</div>
      </div>
      {(isOpen||toggled) && <div className="list-item-subtree" style={{marginLeft:'38px',color:'white',fontSize:'16px'}}>{children}</div>}
    </div>
  );
}

export function Errorlogtreeview({ children }) {
  return <>{children}</>;
}
